import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ScopedCssBaseline } from '@mui/material';
import { type ReactNode } from 'react';

type ConfirmationDialogProps = {
  readonly title: string;
  readonly content: string | ReactNode;
  readonly open: boolean;
  readonly onApprove: () => void;
  readonly onClose: () => void;
  readonly approveButtonLabel?: string;
};

export const ConfirmationDialog = ({
  title,
  content,
  open,
  onApprove,
  onClose,
  approveButtonLabel,
}: ConfirmationDialogProps) => (
  <Dialog
    onClose={onClose}
    open={open}
    slotProps={{ paper: { sx: { p: 1.5, borderRadius: '16px', zIndex: (theme) => theme.zIndex.modal + 1 } } }}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <ScopedCssBaseline>{content}</ScopedCssBaseline>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} type="button" variant="outlined" size="small">
        Abbrechen
      </Button>
      <Button onClick={onApprove} type="button" color="primary" variant="contained" size="small">
        {approveButtonLabel ?? 'Bestätigen'}
      </Button>
    </DialogActions>
  </Dialog>
);
